// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  position: relative;
}
.container:not(:last-child) {
  margin-bottom: 0.5em;
}

.container.width-auto {
  display: inline-block;
}

.container select {
  width: auto;
}

.container.width-100 {
  display: block;
}
.container.width-100 select {
  width: 100%;
}

.container select {
  color: var(--ce-black);
  border: 1px solid var(--ce-grey-10);
  min-height: var(--ce-interactable-min-height);
  font-family: var(--ce-font-family-body);
  font-size: 1em;
  background-image: none;
  width: 100%;
  -webkit-appearance: none;
}

/* Hides scroll bar on select dropdown */
.container select::-webkit-scrollbar {
  width: 0 !important;
}
.container select {
  overflow: -moz-scrollbars-none;
  -ms-overflow-style: none;
}

.arrow {
  position: absolute;
  pointer-events: none;
  right: calc(var(--ce-interactable-min-height) / 1.75);
  top: 50%;
  transform: translate(50%, -50%);
}

.container select {
  border-radius: var(--ce-border-radius-default);
}

.size-small select {
  padding: var(--ce-interactable-padding-small) var(--ce-interactable-min-height) var(--ce-interactable-padding-small)
    var(--ce-interactable-padding-small);
  font-size: var(--ce-body-small);
}

.size-default select {
  padding: var(--ce-interactable-padding-default) var(--ce-interactable-min-height)
    var(--ce-interactable-padding-default) var(--ce-interactable-padding-default);
  font-size: var(--ce-body-default);
}

.size-large select {
  padding: var(--ce-interactable-padding-large) var(--ce-interactable-min-height) var(--ce-interactable-padding-large)
    var(--ce-interactable-padding-large);
  font-size: var(--ce-body-large);
}

/* Intent-based colors */
.intent-none select {
  color: var(--ce-intent-none);
  border-color: var(--ce-intent-none);
}
.intent-none .arrow {
  color: var(--ce-intent-none);
}
.intent-success select {
  color: var(--ce-intent-success);
  border-color: var(--ce-intent-success);
}
.intent-success .arrow {
  color: var(--ce-intent-success);
}
.intent-warning select {
  color: var(--ce-intent-warning);
  border-color: var(--ce-intent-warning);
}
.intent-warning .arrow {
  color: var(--ce-intent-warning);
}
.intent-danger select {
  color: var(--ce-intent-danger);
  border-color: var(--ce-intent-danger);
}
.intent-danger .arrow {
  color: var(--ce-intent-danger);
}
`, "",{"version":3,"sources":["webpack://./src/components/presentational/Select/Select.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;AACA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,mCAAmC;EACnC,6CAA6C;EAC7C,uCAAuC;EACvC,cAAc;EACd,sBAAsB;EACtB,WAAW;EACX,wBAAwB;AAC1B;;AAEA,wCAAwC;AACxC;EACE,mBAAmB;AACrB;AACA;EACE,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,qDAAqD;EACrD,QAAQ;EACR,+BAA+B;AACjC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE;wCACsC;EACtC,+BAA+B;AACjC;;AAEA;EACE;iFAC+E;EAC/E,iCAAiC;AACnC;;AAEA;EACE;wCACsC;EACtC,+BAA+B;AACjC;;AAEA,wBAAwB;AACxB;EACE,4BAA4B;EAC5B,mCAAmC;AACrC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,+BAA+B;EAC/B,sCAAsC;AACxC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;EAC/B,sCAAsC;AACxC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,8BAA8B;EAC9B,qCAAqC;AACvC;AACA;EACE,8BAA8B;AAChC","sourcesContent":[".container {\n  position: relative;\n}\n.container:not(:last-child) {\n  margin-bottom: 0.5em;\n}\n\n.container.width-auto {\n  display: inline-block;\n}\n\n.container select {\n  width: auto;\n}\n\n.container.width-100 {\n  display: block;\n}\n.container.width-100 select {\n  width: 100%;\n}\n\n.container select {\n  color: var(--ce-black);\n  border: 1px solid var(--ce-grey-10);\n  min-height: var(--ce-interactable-min-height);\n  font-family: var(--ce-font-family-body);\n  font-size: 1em;\n  background-image: none;\n  width: 100%;\n  -webkit-appearance: none;\n}\n\n/* Hides scroll bar on select dropdown */\n.container select::-webkit-scrollbar {\n  width: 0 !important;\n}\n.container select {\n  overflow: -moz-scrollbars-none;\n  -ms-overflow-style: none;\n}\n\n.arrow {\n  position: absolute;\n  pointer-events: none;\n  right: calc(var(--ce-interactable-min-height) / 1.75);\n  top: 50%;\n  transform: translate(50%, -50%);\n}\n\n.container select {\n  border-radius: var(--ce-border-radius-default);\n}\n\n.size-small select {\n  padding: var(--ce-interactable-padding-small) var(--ce-interactable-min-height) var(--ce-interactable-padding-small)\n    var(--ce-interactable-padding-small);\n  font-size: var(--ce-body-small);\n}\n\n.size-default select {\n  padding: var(--ce-interactable-padding-default) var(--ce-interactable-min-height)\n    var(--ce-interactable-padding-default) var(--ce-interactable-padding-default);\n  font-size: var(--ce-body-default);\n}\n\n.size-large select {\n  padding: var(--ce-interactable-padding-large) var(--ce-interactable-min-height) var(--ce-interactable-padding-large)\n    var(--ce-interactable-padding-large);\n  font-size: var(--ce-body-large);\n}\n\n/* Intent-based colors */\n.intent-none select {\n  color: var(--ce-intent-none);\n  border-color: var(--ce-intent-none);\n}\n.intent-none .arrow {\n  color: var(--ce-intent-none);\n}\n.intent-success select {\n  color: var(--ce-intent-success);\n  border-color: var(--ce-intent-success);\n}\n.intent-success .arrow {\n  color: var(--ce-intent-success);\n}\n.intent-warning select {\n  color: var(--ce-intent-warning);\n  border-color: var(--ce-intent-warning);\n}\n.intent-warning .arrow {\n  color: var(--ce-intent-warning);\n}\n.intent-danger select {\n  color: var(--ce-intent-danger);\n  border-color: var(--ce-intent-danger);\n}\n.intent-danger .arrow {\n  color: var(--ce-intent-danger);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
